import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as Parse from 'parse';
import { Store } from '@ngrx/store';
import * as fromAuth from '@app/store/auth';
import { AppState } from '@app/store/state';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private store: Store<AppState>) {}

    intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        let accessToken = Parse.User.current()?.getSessionToken() || '';

        if (!accessToken) {
            const authData = JSON.parse(localStorage.getItem('vimo_auth')!);
            accessToken = authData.access_token;
        }

        return next.handle(this.addAuthorizationHeader(req, accessToken)).pipe(
            catchError((err) => {
                if (err instanceof HttpErrorResponse && err.status === 401) {
                    this.logoutAndRedirect(err);
                }
                if (err instanceof HttpErrorResponse && err.status === 403) {
                    this.logoutAndRedirect(err);
                }
                return throwError(err);
            })
        );
    }

    private addAuthorizationHeader<T>(request: HttpRequest<T>, token: string): HttpRequest<T> {
        if (token) {
            return request.clone({
                setHeaders: { Authorization: `Bearer ${token}` }
            });
        }
        return request;
    }

    private logoutAndRedirect(err: Error): Observable<void> {
        this.store.dispatch(fromAuth.LogOutWithSupabase());
        return throwError(err);
    }
}
